import { IconNames } from '@blueprintjs/icons';
import { sortAsc } from '@strata/helper-functions';
import { GridWithSearch, PrimaryData, SecondaryData } from '@strata/react-grid';
import { Icon } from '@strata/react-status-icons';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';

import { ListPageHeader } from 'components/ListPageHeader';
import { CREATE_ROUTE } from 'services/constants';
import { useGet } from 'services/Http';
import {
    getTherapyGroupListRows,
    therapyGroupAppPath,
    TherapyGroupsApiUrl,
} from 'services/TherapyGroupHelpers';

const columns = ({ navigate }) => [
    {
        accessorKey: 'description',
        header: 'Therapy Group',
        size: 220,
        cell: ({ getValue }) => <PrimaryData data={getValue()} />,
    },
    {
        accessorKey: 'parentProducts',
        header: 'Parent Products',
        size: 160,
        cell: ({ getValue }) => <SecondaryData data={getValue().sort(sortAsc).join(', ')} />,
    },
    {
        header: 'Actions',
        accessorKey: 'actions',
        size: 40,
        enableSorting: false,
        cell: ({ row }) => (
            <div className="sds_filter-list__actions">
                <Icon
                    icon={IconNames.EDIT}
                    intent={Icon.Intent.SECONDARY}
                    title="Edit"
                    onClick={() =>
                        navigate({
                            pathname: therapyGroupAppPath(row.original.therapy_group_name),
                        })
                    }
                />
            </div>
        ),
    },
];

export const TherapyGroupList = () => {
    const navigate = useNavigate();

    const therapyGroups = useGet(TherapyGroupsApiUrl);
    const rows = useMemo(
        () => (therapyGroups ? getTherapyGroupListRows(therapyGroups) : undefined),
        [therapyGroups],
    );

    return (
        <div className="sds_main-content__container">
            <ListPageHeader
                pageTitle="Therapy Groups"
                buttons={[
                    {
                        label: 'Add Therapy Group',
                        path: therapyGroupAppPath(CREATE_ROUTE),
                    },
                ]}
            />
            <div className="sds_main-content__grid">
                <GridWithSearch
                    data={rows}
                    isLoading={!rows}
                    columns={columns({ navigate })}
                    sortProperties={[{ id: 'description', desc: false }]}
                    onRowClick={(row) => navigate(therapyGroupAppPath(row.therapy_group_name))}
                />
            </div>
        </div>
    );
};
